import { useTranslation } from "react-i18next";
import {
  Button,
  Col,
  DatePicker,
  Form,
  FormInstance,
  Row,
  Typography,
} from "antd";
import React from "react";
import FormItemDropdown from "../../../../form-dropdown/FormItemDropdown";
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";

type FilterBankQuestionListTypes = {
  tab: string;
  form: FormInstance;
  showFilter: boolean;
  dataUniversity: any;
  clearFilter: () => void;
  onFinish: (values: any) => void;
};

const FilterBankQuestionList = ({
  tab,
  form,
  showFilter,
  dataUniversity,
  onFinish,
  clearFilter,
}: FilterBankQuestionListTypes) => {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;

  const permissionOptions = [
    // {
    //   value: 1,
    //   label: t("Tác giả", "Tác giả"),
    // },
    {
      value: 2,
      label: t("Xem", "Xem"),
    },
    {
      value: 3,
      label: t("Chỉnh sửa", "Chỉnh sửa"),
    },
  ];

  return (
    <div
      className={`wrapper-filter ${showFilter ? "open" : ""}`}
      hidden={!showFilter}
    >
      <Form form={form} name="filterForm" onFinish={onFinish}>
        <Row gutter={[{ xs: 8, xl: 24, md: 16 }, 12]}>
          {tab === "2" ? (
            <>
              <Col
                xl={{ span: 5 }}
                md={{ span: 5 }}
                sm={{ span: 5 }}
                xs={{ span: 24 }}
              >
                <Typography.Title level={5}>{t("Trường sở hữu", "Trường sở hữu")}</Typography.Title>
                <Form.Item name="owner">
                  <FormItemDropdown
                    allowClear
                    options={dataUniversity}
                    modeDropdown="multiple"
                    placeholder={t("Chọn trường sở hữu", "Chọn trường sở hữu")}
                  />
                </Form.Item>
              </Col>
              <Col
                xl={{ span: 5 }}
                md={{ span: 5 }}
                sm={{ span: 5 }}
                xs={{ span: 24 }}
              >
                <Typography.Title level={5}>{t("Quyền chia sẻ", "Quyền chia sẻ")}</Typography.Title>
                <Form.Item name="permission">
                  <FormItemDropdown
                    placeholder={t("Chọn quyền chia sẻ", "Chọn quyền chia sẻ")}
                    options={permissionOptions}
                  />
                </Form.Item>
              </Col>
            </>
          ) : null}

          <Col
            xl={{ span: 6 }}
            md={{ span: 6 }}
            sm={{ span: 6 }}
            xs={{ span: 24 }}
          >
            <Typography.Title level={5}>
              {t("Thời gian sửa đổi (theo ngày)", "Thời gian sửa đổi (theo ngày)")}
            </Typography.Title>
            <Form.Item name="updatedDate">
              <RangePicker
                placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]}
                format="DD-MM-YYYY"
              />
            </Form.Item>
          </Col>
          <Col
            xl={{ span: 3 }}
            md={{ span: 9 }}
            sm={{ span: 9 }}
            xs={{ span: 24 }}
            className="flex align-end"
          >
            <div className="group-btn--filter">
              <Button className="btn btn-primary filter-btn" htmlType="submit">
                <FilterOutlined />
                <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
              </Button>
              <Button
                className="btn btn-outlined clear-filter-btn"
                onClick={clearFilter}
              >
                <DeleteOutlined />
                <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default FilterBankQuestionList;